// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608110551/js/" + chunkId + "." + {"44":"22c4ce17","225":"50f518ea","481":"f5eda9f9","486":"330b0bc1","770":"61a47b65"}[chunkId] + ".0.3733504436947547.chunk.js";
};